import { type PublicClip } from '@air/api';
import { type Clip } from '@air/api/types';

import { GalleryItemType } from '~/components/Gallery/types';

export const isAssetFileType = (asset: Pick<Clip | PublicClip, 'type'>) => asset.type === 'nonMedia';

export const getAssetGalleryItemType = (asset: Pick<Clip | PublicClip, 'type'>) =>
  isAssetFileType(asset) ? GalleryItemType.file : GalleryItemType.asset;
